import lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import data from '../../assets/xloading.json';

function Loading() {

    const lottieRef = useRef(null);

    useEffect(() => {
        lottie.destroy();
        lottie.loadAnimation({
            container: lottieRef.current!,
            loop: true,
            autoplay: true,
            renderer: 'svg',
            animationData: data
        });
    }, []);

    return (
        <div className="flex flex-col justify-center items-center">
            <div ref={lottieRef} className='w-14 h-14' ></div>
            <span className='text-mx-quaternary text-size-3.5 mt-3'>加载中</span>
        </div>
    )
}

function LoadMore() {

    const lottieRef = useRef(null);

    useEffect(() => {
        lottie.destroy();
        lottie.loadAnimation({
            container: lottieRef.current!,
            loop: true,
            autoplay: true,
            renderer: 'svg',
            animationData: data
        });
    }, []);

    return (
        <div className="flex flex-justify-center flex-items-center mt-2">
            <div ref={lottieRef} className='w-6 h-6' ></div>
            <span className='text-mx-quaternary text-size-3.5 ml-1'>加载中</span>
        </div>
    )
}

export {
    Loading,
    LoadMore
}